export const MemberOrderEvaluationCn = {
    xunjiadang:'订单评价',
    wodepingji:'我的评价',
    daipingjia:'待评价订单',
    didangneirong:'订单内容',
    pingjianeirong:'评价内容',
    jiage:'价格',
    zhuantai:'状态',
    caozuo:'操作',
    pingjiazhuantai:'评价状态'
  }
  


// WEBPACK FOOTER //
// ./src/lang/member/MemberOrderEvaluation/MemberOrderEvaluationCn.js